import CompanyPositionsForm from "./company_position_form.store";
import CompanyPositionList from "./company_position_list.store";

export default {
  modules: {
    CompanyPositionsForm,
    CompanyPositionList,
  },
};
